export default __webpack_public_path__ + "static/media/VRGame.d2caa1b6.mp4";